'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var ConfirmButton = exports.ConfirmButton = undefined;

exports.ConfirmButton = ConfirmButton = function ConfirmButton(refs, _ref) {
    var _ref$type = _ref.type,
        type = _ref$type === undefined ? 'confirm' : _ref$type,
        _ref$text = _ref.text,
        text = _ref$text === undefined ? 'OK' : _ref$text,
        _ref$fn = _ref.fn,
        fn = _ref$fn === undefined ? Function.prototype : _ref$fn,
        _ref$closeFn = _ref.closeFn,
        closeFn = _ref$closeFn === undefined ? Function.prototype : _ref$closeFn,
        _ref$applyConfig = _ref.applyConfig,
        applyConfig = _ref$applyConfig === undefined ? {} : _ref$applyConfig;

    var i18n = refs.i18nManager.get();

    var defaults = {
        padding: '0 3px',
        borderRadius: '2px',
        fontWeight: 'bold',
        btnHeight: 29
        //btnWidth: text ? null : 72
    };

    var typeStyle = {
        'confirm': {
            color: '#fff',
            borderColor: '#3079ed',
            background: '#619dff'
        },
        'close': {
            color: '#555',
            borderColor: '#ccc'
        }
    };

    var style = _extends(defaults, typeStyle[type]);

    return Ext.create('Ext.button.Button', _extends({
        xtype: 'button',
        //width: defaults.btnWidth,
        height: defaults.btnHeight,
        minWidth: 72,
        text: '<span style="color:' + style.color + '; font-weight:' + style.fontWeight + '; padding:' + style.padding + '">' + text + '</span>',
        style: 'border-color:' + style.borderColor + '; background:' + style.background + '; border-radius:' + style.borderRadius,
        handler: function handler() {
            fn();
            closeFn();
        }
    }, applyConfig));
};
//# sourceMappingURL=ConfirmButton.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/ConfirmButton.js
 ** module id = 153
 ** module chunks = 0 1
 **/